import React from 'react';

const listItems = [
  {
    title: 'Project Owner',
    description: (
      <>
        Full access, can manage permissions and transfer project ownership. Only the project owner can sign and submit a
        request.
        <br />
        NOTE: A user must have been previously granted Read/Write or Read access to be granted project ownership.
      </>
    ),
  },
  {
    title: 'Read/Write',
    description: 'Can view and edit the request, but cannot manage permissions or sign and submit the request.',
  },
  { title: 'Read Only', description: 'Can view the request, but cannot make any changes.' },
];

export const PermissionsInfoAlert = () => (
  <div className='usa-alert callout'>
    <div className='usa-alert__body'>
      <h5>Permission Levels</h5>
      <div className='usa-alert__text'>
        <ul style={{ listStyleType: 'none', paddingLeft: '20px' }}>
          {listItems.map((item) => (
            <li key={item.title}>
              <span className='text-bold'>{item.title}:</span> {item.description}
            </li>
          ))}
        </ul>
      </div>
    </div>
  </div>
);
